<template>
  <div>
    <el-dialog
      @close = "closeDialog"
      custom-class="volunteermodel1"
      title="欢迎注册"
      :visible.sync="centerDialogVisible.ifshow"
      width="40%"
      center>
      <el-form ref="Formdata" :model="Fromdata" :rules="Rules" class="volunteer">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="Fromdata.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="Fromdata.sex" placeholder="请选择性别">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="Fromdata.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="Fromdata.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="政治面貌" prop="politicalState">
          <el-select v-model="Fromdata.politicalState" placeholder="请选择政治面貌">
            <el-option :label="item.dictName" :value="item.dictCode" v-for="(item, index) in politicalStateArr" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类别" prop="serviceType">
          <el-select v-model="Fromdata.serviceType" placeholder="请选择服务类别">
            <el-option :label="item.dictName" :value="item.dictCode" v-for="(item, index) in serviceTypeArr" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务区域" prop="serviceArea">
          <el-select v-model="Fromdata.serviceArea" placeholder="请选择服务区域">
            <el-option :label="item.dictName" :value="item.dictCode" v-for="(item, index) in serviceAreaArr" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="introduction" label="简介" prop="introduction">
          <el-input type="textarea" v-model="Fromdata.introduction" placeholder="请输入简介"></el-input>
        </el-form-item>
        <el-form-item label="上传头像">
          <el-upload
            action
            list-type="picture-card"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed = "overUpload"
            :http-request="upLoadimg"
            ref="uploads"
            :limit=1
            class="upload-demo"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div class="defaulttext">点击上传</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="registerbtn">注册</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploads } from '@/api/workCollect/index'
import { registerVolunteer } from '@/api/volunteer/index'
export default {
  name: 'registervolunteer',
  props: ['menuId', 'centerDialogVisible', 'politicalStateArr', 'serviceTypeArr', 'serviceAreaArr'],
  data () {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        if (value.length === 11) {
          callback()
        } else {
          return callback(new Error('请输入11位'))
        }
      }
    }
    return {
      Fromdata: {
        fid: this.$cookie.get('culturalCloud_fid'),
        menuId: '',
        name: '',
        sex: '',
        phone: '',
        idCard: '',
        introduction: '',
        image: '',
        politicalState: '',
        serviceType: '',
        serviceArea: ''
      },
      images: [],
      Rules: {
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        sex: [{required: true, message: '请选择性别', trigger: 'blur'}],
        phone: [{required: true, message: '请输入手机号码', validator: checkPhone, trigger: 'blur'}],
        idCard: [{required: true, message: '请输入身份证号', trigger: 'blur'}],
        introduction: [{required: true, message: '简介不能为空', trigger: 'blur'}],
        politicalState: [{required: true, message: '请选择政治面貌', trigger: 'blur'}],
        serviceType: [{required: true, message: '请选择服务类别', trigger: 'blur'}],
        serviceArea: [{required: true, message: '请选择服务区域', trigger: 'blur'}]
      },
      volunteertypeArr: [],
      imgstring: ''

    }
  },
  mounted () {
  },
  methods: {
    closeDialog () {
      this.$emit('closeDiglog', this.centerDialogVisible.ifshow)
    },
    registerbtn () {
      this.$refs['Formdata'].validate((valid) => {
        if (valid) {
          this.Fromdata.menuId = this.menuId
          registerVolunteer(this.Fromdata).then(res => {
            if (res.data.rel) {
              this.centerDialogVisible = false
              this.$message({
                message: res.data.message,
                type: 'success',
                duration: 1500
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    upLoadimg (param) {
      this.images.push(param)
      this.getImgs()
    },
    getImgs () {
      const paramsData = new FormData()
      this.images.forEach((it, index) => {
        paramsData.append('file', it.file)
      })
      // console.log(paramsData);
      uploads(paramsData).then(res => {
        this.imgarr = []
        res.data.data.forEach(item => {
          this.imgarr.push(item.http)
        })
        this.imgstring = this.imgarr[0]
        this.Fromdata.image = this.imgstring
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传5MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.images.forEach((item, index) => {
        if (item.file === file.raw) {
          this.images.splice(index, 1)
        }
      })
      this.Fromdata.image = ''
    },
    overUpload () {
      this.$message('只能上传一张封面')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .volunteermodel1{
  height: 500px;
  overflow-y: auto;
  padding: 0 0 30px;
}
/deep/ .el-form.volunteer{
  .el-form-item{
    .el-form-item__label{
      width: 100px;
    }
    .el-form-item__content{
      width: 50%;
      float: left;
      .el-select{
        width: 100%;
      }
      .upload-demo{
        .el-upload{
          position: relative;
          .defaulttext {
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: #c5c5c5;
            position: absolute;
            top: 60%;
            left: 50%;
            margin-left: -40px;
          }
        }
      }
    }
    &.introduction{
      .el-form-item__content{
        width: 78%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/registervolunteer.vue